<template>
<pop-up-layout 
  :title="$t('general.popUpSincronizacion.titulo')"
  :description="$t('general.popUpSincronizacion.descripcion')"
  :aceptar="$t('general.misc.reintentar')"
>
  <v-layout column justify-center align-center>
    <o-description-title v-if="error" colorClass="error--text">{{error}}</o-description-title>
    <v-btn color="primary" @click="cerrarPopup()">
      {{textoBoton}}
    </v-btn>
  </v-layout>
  <div slot="acciones"/>
</pop-up-layout>
</template>

<script>
export default {
  props: {
    error: {
      type: String,
      default: '',
      required: true
    },
    textoBoton: {
      default () {
        return this.$t('general.misc.continuar')
      }
    }
  },
  methods: {
    cerrarPopup () {
      this.$emit('hide')
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/generic/PopUpSincronizacion.vue